<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Fraccionamiento      -->
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-basic
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :src="imageFrontURL">
                    </clipper-basic>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="getCutingLogo()"
                    >{{$t('recortar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('Fraccionamientos')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on " @click="update = false, clean_fields()"> + {{$t('AnadirFraccionamiento')}}</v-btn>
                </template>
                <v-form
                        @submit.prevent="update ? update_housing_unit(id_update) : alta_housing_unit()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{$t('Fraccionamientos')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="name"
                                            v-if="dialog" autofocus
                                            prepend-icon="mdi-home-city"
                                            name="name"
                                            :label="$t('nombre')"
                                            :error-messages="errores.name"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="address"
                                            prepend-icon="mdi-map-marker"
                                            name="address"
                                            :label="$t('direccion')"
                                            :error-messages="errores.address"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-label>{{$t('telefono')}}</v-label>
                                    <vue-tel-input
                                            class="mt-3 mb-3"
                                            v-model="telephone"
                                            @onInput="onInput"
                                    >
                                    </vue-tel-input>
                                    <v-alert
                                            outlined
                                            v-if="errores.telephone"
                                            type="error"
                                    >
                                        {{errores.telephone}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('logotipo')}}
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultLogoURL"
                                            v-if="resultLogoURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageLogo = true"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores.logo"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.logo}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            v-model="web_page"
                                            prepend-icon="mdi-web"
                                            name="web_page"
                                            :label="$t('pagina_web')"
                                            :error-messages="errores.web_page"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                            v-model="latitude"
                                            prepend-icon="mdi-crosshairs-gps"
                                            name="latitude"
                                            :label="$t('latitud')"
                                            :error-messages="errores.latitude"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                            v-model="longitude"
                                            prepend-icon="mdi-crosshairs-gps"
                                            name="longitude"
                                            :label="$t('longitud')"
                                            :error-messages="errores.longitude"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                            v-model="url_map"
                                            prepend-icon="mdi-lock"
                                            name="url_map"
                                            :label="$t('url_mapa')"
                                            :error-messages="errores.url_map"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('Fraccionamientos')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loading_data_housing_units"
                        :items="housing_units"
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                >
                    <template v-slot:item.logo="{ item }">
                        <v-img  width="100" :src="item.logo"></v-img>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fill_fields(item), update = true, dialog = true, id_update = item.id"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>{{$t('change')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:no-results>
                        <v-alert  type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'housing_units',
  data: () => ({
    alerta: false,
    calendario: false,
    parques: [],
    administradores: [],
    housing_units: [],
    dialog: false,
    update: false,
    id_update: 0,
    name: '',
    address: '',
    telephone: '',
    email: '',
    logo: '',
    web_page: '',
    scian: '',
    classification: '',
    latitude: '',
    longitude: '',
    url_map: '',
    validity: '',
    id_parque: '',
    errores: [],
    search: '',
    headers: [],
    loading_data_housing_units: false,
    loading: false,
    dialogImageLogo: false,
    imageFrontURL: '',
    resultLogoURL: '',
    resultAuxLogoURL: '',
    band_cellphone: false,
    dialogCellNumberWrong: false
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('nombre'),
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('telefono'),
        align: 'left',
        sortable: true,
        value: 'telephone'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'email'
      },
      {
        text: this.$t('logotipo'),
        align: 'left',
        sortable: true,
        value: 'logo'
      },
      {
        text: this.$t('pagina_web'),
        align: 'left',
        sortable: true,
        value: 'web_page'
      },
      {
        text: this.$t('latitud'),
        align: 'left',
        sortable: true,
        value: 'latitude'
      },
      {
        text: this.$t('longitud'),
        align: 'left',
        sortable: true,
        value: 'longitude'
      },
      {
        text: this.$t('url_mapa'),
        align: 'left',
        sortable: true,
        value: 'url_map'
      }
    ]
  },
  created: function () {
    this.get_housing_units()
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    get_housing_units: function () {
      this.loading_data_housing_units = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/housing_unit/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.housing_units = response.data
          this.loading_data_housing_units = false
        })
        .catch(error => {
          this.loading_data_housing_units = false
          console.log(error)
        })
    },
    alta_housing_unit: function () {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        const newID = this.$uuid.v4()
        var bodyFormData = new FormData()
        var fileImageFront = null

        bodyFormData.set('name', this.name)
        bodyFormData.set('address', this.address)
        bodyFormData.set('telephone', this.telephone)
        bodyFormData.set('email', this.email.toLowerCase())
        if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo' + newID + '.jpeg')
        }
        bodyFormData.append('logo', fileImageFront)
        bodyFormData.set('web_page', this.web_page)
        bodyFormData.set('scian', this.scian)
        bodyFormData.set('classification', this.classification)
        bodyFormData.set('latitude', this.latitude)
        bodyFormData.set('longitude', this.longitude)
        bodyFormData.set('url_map', this.url_map)
        bodyFormData.set('validity', this.validity)
        bodyFormData.set('id_parque', this.id_parque)
        const config = {
          method: 'post',
          url: 'https://residencial-services.intrare.app/housing_unit/',
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_alta'))
            this.dialog = false
            this.get_housing_units()
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    update_housing_unit (id) {
      if (this.band_cellphone === true) {
        this.loading = true
        this.errores = []
        var bodyFormData = new FormData()
        var fileImageFront = null
        bodyFormData.set('name', this.name)
        bodyFormData.set('address', this.address)
        bodyFormData.set('telephone', this.telephone)
        bodyFormData.set('email', this.email.toLowerCase())
        if (this.resultLogoURL !== this.resultAuxLogoURL) {
          const newID = this.$uuid.v4()
          if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo_update' + newID + '.jpeg')
          }
          bodyFormData.append('logo', fileImageFront)
        }
        bodyFormData.set('web_page', this.web_page)
        bodyFormData.set('latitude', this.latitude)
        bodyFormData.set('longitude', this.longitude)
        bodyFormData.set('url_map', this.url_map)
        const config = {
          method: 'put',
          url: 'https://residencial-services.intrare.app/housing_unit/' + id,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            console.log(this.id_parque)
            this.get_housing_units()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_modificado'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    clear: function () {
      this.alerta = false
      this.errores = []
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    fill_fields (item) {
      this.name = item.name
      this.address = item.address
      this.telephone = item.telephone
      this.email = item.email
      this.web_page = item.web_page
      this.scian = item.scian
      this.classification = item.classification
      this.latitude = item.latitude
      this.longitude = item.longitude
      this.url_map = item.url_map
      this.validity = item.validity
      this.id_parque = item.id_parque
      this.resultLogoURL = item.logo
      this.resultAuxLogoURL = item.logo
      this.band_cellphone = true
    },
    customFilter (item, queryText) {
      const textOne = item.nombre.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    clean_fields () {
      this.name = ''
      this.address = ''
      this.telephone = ''
      this.email = ''
      this.logo = ''
      this.web_page = ''
      this.scian = ''
      this.classification = ''
      this.latitude = ''
      this.longitude = ''
      this.url_map = ''
      this.validity = ''
      this.id_parque = ''
      this.resultLogoURL = ''
      this.resultAuxLogoURL = ''
    },
    getCutingLogo () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultLogoURL)
      this.dialogImageLogo = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      console.log(country)
      this.telephone = number.e164
      this.band_cellphone = isValid
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #81c81b #81c81b #81c81b #81c81b;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #81c81b;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
